const MAX_PATH_LENGTH = 200

// Obfuscate the emails in the paths for privacy
const EMAIL_PATTERN = /[\p{L}\p{M}\p{N}._%+-]{1,64}(?:@|%40)[\p{L}\p{M}\p{N}-]+(?:\.[\p{L}\p{M}\p{N}-]+)*\.\p{L}{2,}/giu

export const redactEmails = (text: string): string => text.replace(EMAIL_PATTERN, '[email]')

export const formatPathForLog = (segments: string[]): string => {
  const path = redactEmails(`/${segments.join('/')}`)

  return path.length > MAX_PATH_LENGTH ? `${path.slice(0, MAX_PATH_LENGTH)}...` : path
}
